import { trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2';

export const HP_VIDEO_AUTO_PLAY_TEST_NAME = 'HPVideoAutoPlay' as const;

export const trackHPVideoAutoPlayTest = (): void => {
    trackAbTestV2Variant(HP_VIDEO_AUTO_PLAY_TEST_NAME);
};
